"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrumpetIcon = function TrumpetIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "74px", height: "70px", viewBox: "0 0 74 70", version: "1.1" },
    _react2.default.createElement(
      "title",
      null,
      "Icon - happy"
    ),
    _react2.default.createElement(
      "defs",
      null,
      _react2.default.createElement("polygon", {
        id: "path-1",
        points: "0.295069239 0.51519089 9.80787538 0.51519089 9.80787538 10.1505453 0.295069239 10.1505453"
      }),
      _react2.default.createElement("path", {
        d: "M14.0402712,24.3131427 C4.78814682,14.9168968 -1.4384479,4.20369227 0.825204223,1.28476531 C3.19419817,-1.77032151 14.5909217,4.96020712 23.8442431,14.3576688 C33.0963675,23.7551304 39.2534281,34.7030216 36.5456644,37.4529644 C31.5833834,38.8333163 23.2935927,33.7093886 14.0402712,24.3131427 Z",
        id: "path-3"
      })
    ),
    _react2.default.createElement(
      "g",
      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { id: "6.0-MuchBetter---Sucsess", transform: "translate(-151.000000, -131.000000)" },
        _react2.default.createElement(
          "g",
          { id: "Content", transform: "translate(20.000000, 116.000000)" },
          _react2.default.createElement(
            "g",
            { id: "image_summary", transform: "translate(118.000000, 0.000000)" },
            _react2.default.createElement(
              "g",
              { id: "Icon---happy", transform: "translate(13.333333, 15.000000)" },
              _react2.default.createElement("path", {
                d: "M1.96975925,68.7943748 L55.8867574,50.2000601 L55.8867574,50.2000601 L19.7992866,14.1645376 L0.70223984,67.5119829 C0.516102726,68.0319554 0.786729793,68.6043704 1.30670231,68.7905075 C1.52084953,68.8671668 1.7547324,68.868531 1.96975925,68.7943748 Z",
                id: "Fill-1",
                fill: "#C4D7FF"
              }),
              _react2.default.createElement("path", {
                d: "M1.97249121,68.8006291 L9.42668197,66.2571038 L9.42668197,66.2571038 L6.83479801,50.5876341 L0.709235249,67.5139112 C0.521293954,68.0332344 0.78993201,68.6065855 1.30925514,68.7945268 C1.5232019,68.8719534 1.75715601,68.8741059 1.97249121,68.8006291 Z",
                id: "Fill-2",
                fill: "#94C0FF"
              }),
              _react2.default.createElement("polygon", {
                id: "Fill-3",
                fill: "#94C0FF",
                points: "16.1600262 24.8530994 22.3787609 62.0541645 32.9933869 58.4309232 26.8787046 21.8519283 19.7813055 14.8390393"
              }),
              _react2.default.createElement(
                "g",
                { id: "Group-22", transform: "translate(18.853364, 0.000000)" },
                _react2.default.createElement(
                  "g",
                  { id: "Group-21", transform: "translate(0.000000, 0.095587)" },
                  _react2.default.createElement("path", {
                    d: "M50.7239766,11.4089729 C50.1494031,11.4089729 49.5748297,11.1879933 49.1359722,10.7421797 C47.752176,9.34178553 45.9130335,8.56964158 43.9559322,8.56964158 C42.0000992,8.56964158 40.1609567,9.34178553 38.7771605,10.7421797 C37.900714,11.6312373 36.4788665,11.6312373 35.6011516,10.7421797 C34.7247051,9.85440689 34.7247051,8.41418498 35.6011516,7.52641215 C37.8334901,5.2652252 40.8002173,4.02028761 43.9559322,4.02028761 C47.1129154,4.02028761 50.0796426,5.2652252 52.3119811,7.52641215 C53.1884276,8.41418498 53.1884276,9.85440689 52.3119811,10.7421797 C51.8731236,11.1867085 51.2985501,11.4089729 50.7239766,11.4089729",
                    id: "Fill-6",
                    fill: "#FCE68D"
                  }),
                  _react2.default.createElement("path", {
                    d: "M39.1216509,18.8157734 L40.2162578,16.4839244 C40.5955017,15.675807 41.6583992,15.5049332 42.2659504,16.1550245 L44.0175751,18.0307818 C44.2167099,18.2427681 44.4818001,18.380238 44.7671843,18.4174962 L47.2963223,18.7515351 C48.1727689,18.867164 48.6610929,19.8371618 48.237456,20.6234382 L47.0185484,22.891049 C46.8790272,23.148002 46.8333658,23.4460676 46.8866375,23.733855 L47.3546675,26.2725513 C47.5170194,27.1513308 46.7572633,27.9221899 45.888427,27.75774 L43.3808513,27.2836616 C43.0980039,27.2297014 42.8037411,27.2772378 42.5500663,27.4172772 L40.3101175,28.6519366 C39.5351409,29.0797635 38.57625,28.5851288 38.4633647,27.6999255 L38.1348558,25.1381035 C38.0955362,24.8477466 37.9610886,24.5792306 37.7518068,24.3775224 L35.8999806,22.6019768 C35.2581833,21.987859 35.4256086,20.9125104 36.2246844,20.5283656 L38.5267834,19.4196131 C38.7868001,19.2937061 38.9973503,19.0804351 39.1216509,18.8157734",
                    id: "Fill-8",
                    fill: "#80AAFF"
                  }),
                  _react2.default.createElement(
                    "g",
                    { id: "Group-12", transform: "translate(20.293986, 0.000000)" },
                    _react2.default.createElement(
                      "mask",
                      { id: "mask-2", fill: "white" },
                      _react2.default.createElement("use", { href: "#path-1" })
                    ),
                    _react2.default.createElement("g", { id: "Clip-11" }),
                    _react2.default.createElement("path", {
                      d: "M9.80787538,5.33267538 C9.80787538,7.99342434 7.67827518,10.1505453 5.05147231,10.1505453 C2.42466944,10.1505453 0.295069239,7.99342434 0.295069239,5.33267538 C0.295069239,2.67192642 2.42466944,0.51480546 5.05147231,0.51480546 C7.67827518,0.51480546 9.80787538,2.67192642 9.80787538,5.33267538",
                      id: "Fill-10",
                      fill: "#FCD7A2",
                      mask: "url(#mask-2)"
                    })
                  ),
                  _react2.default.createElement(
                    "g",
                    { id: "Group", transform: "translate(0.341365, 13.167560)" },
                    _react2.default.createElement(
                      "mask",
                      { id: "mask-4", fill: "white" },
                      _react2.default.createElement("use", { href: "#path-3" })
                    ),
                    _react2.default.createElement("use", { id: "Fill-13", fill: "#5084D0", href: "#path-3" })
                  ),
                  _react2.default.createElement("path", {
                    d: "M44.7234183,45.4278764 C43.8770147,45.4299177 43.0673058,44.9451797 42.6898607,44.1190931 C40.9906862,40.4171151 36.6241972,38.8186254 32.9590837,40.5559735 C31.8322385,41.0890583 30.4971911,40.5991704 29.9758262,39.4626651 C29.4544613,38.3261597 29.94371,36.9727544 31.0705552,36.4396696 C36.9842801,33.6374483 44.0259399,36.2157014 46.7665843,42.1868408 C47.2879492,43.3233461 46.7974285,44.6780387 45.6718523,45.2111204 C45.3644144,45.3569745 45.04193,45.4270994 44.7234183,45.4278764",
                    id: "Fill-15",
                    fill: "#E7B1F2",
                    transform: "translate(38.371103, 40.367533) rotate(-11.000000) translate(-38.371103, -40.367533) "
                  }),
                  _react2.default.createElement("path", {
                    d: "M11.6161964,22.9479641 C11.0416229,22.9479641 10.4670494,22.7256997 10.028192,22.2811709 C9.15174543,21.3933981 9.15174543,19.9531761 10.028192,19.0654033 C11.4119882,17.6637244 12.1730127,15.8008147 12.1730127,13.8184218 C12.1730127,11.8373137 11.4119882,9.97311921 10.028192,8.57272502 C9.15174543,7.68366742 9.15174543,6.24344551 10.028192,5.35567268 C10.9046385,4.46661508 12.3277543,4.46661508 13.2042008,5.35567268 C15.435271,7.61557486 16.6643255,10.6219257 16.6643255,13.8184218 C16.6643255,17.0149179 15.435271,20.0212687 13.2042008,22.2811709 C12.7653434,22.7256997 12.1907699,22.9479641 11.6161964,22.9479641",
                    id: "Fill-17",
                    fill: "#A6E87C"
                  }),
                  _react2.default.createElement("path", {
                    d: "M29.1334581,27.2691437 C29.1334581,29.9298927 27.0038579,32.0870137 24.3770551,32.0870137 C21.7502522,32.0870137 19.620652,29.9298927 19.620652,27.2691437 C19.620652,24.6083948 21.7502522,22.4512738 24.3770551,22.4512738 C27.0038579,22.4512738 29.1334581,24.6083948 29.1334581,27.2691437",
                    id: "Fill-19",
                    fill: "#C4D7FF"
                  })
                )
              )
            )
          )
        )
      )
    )
  );
};

exports.default = TrumpetIcon;